/* eslint-disable */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { Controller, useForm, useWatch } from "react-hook-form";
import api from "api";
import { useLookups } from "context/lookupsContext";
import { handleLoading, useLoading } from "context/LoadingContext";
import { generateTextFromJson } from "utils/generateTextFromJson";
import addNewLog from "utils/addNewLog";
import { useAuth } from "context/auth";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function AddEditEmployeeModal(props) {
  const [, loadingDispatch] = useLoading();
  const [auth] = useAuth();
  const { togglePrintDialog, getUsers, userData, addOrEdit } = props;
  const [lookups] = useLookups();
  const { RolesNoPeople, Permissions } = lookups;
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  const permissionArray = useWatch({ control, name: "permissionArray" });
  const roleId = useWatch({ control, name: "roleId" });

  const permissionArrayValue = useMemo(() => {
    if (!Permissions) return [];
    return Permissions.filter((permission) =>
      permissionArray?.includes(permission.id)
    );
  }, [permissionArray]);

  useEffect(() => {
    if (userData) {
      const userDataTemp = {
        ...userData,
        permissionArray: userData.permissions,
      };
      reset(userDataTemp);
    }
  }, [userData]);

  const onSubmit = async (data) => {
    try {
      handleLoading(loadingDispatch, true);
      const { permissionArray: permissionArrayFromForm } = data;
      await api.post("users/admin/signup/", {
        ...data,
        roleId: data.roleId - 0,
        permissionArray: permissionArrayFromForm || [],
      });
      await addNewLog({
        ipAddress: auth.ipAddress,
        hostname: auth.hostname,
        logDescription: `${generateTextFromJson(data,"أضافة موظف جديد")} `});  
      togglePrintDialog();
      getUsers();
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  };
  const onEditSubmit = async (data) => {
    const { permissionArray: permissionArrayFromForm } = data;
    await addNewLog({
      ipAddress: auth.ipAddress,
      hostname: auth.hostname,
      logDescription: `${generateTextFromJson(data,"تعديل على بيانات موظف")} `});

    try {
      await api.patch("users/admin", {
        ...data,
        roleId: data.roleId - 0,
        permissionArray: permissionArrayFromForm || [],
      });
      togglePrintDialog();
      getUsers();
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
  };

  let submitToGo;
  if (addOrEdit === "add") submitToGo = onSubmit;
  if (addOrEdit === "edit") submitToGo = onEditSubmit;
  return (
    <form
      onSubmit={handleSubmit(submitToGo)}
      autoComplete="new-password"
      noValidate
    >
      {addOrEdit === "add" && (
        <Form.Group className="mb-3 input input-md" controlId="userName">
          <Form.Label>اسم المستخدم</Form.Label>
          <Form.Control
            autoComplete="new-password"
            type="text"
            {...register("userName", {
              required: "الرجاء إدخال الحقل",
            })}
          />

          {errors.userName && (
            <Form.Text className="text-danger">
              {errors.userName.message}
            </Form.Text>
          )}
        </Form.Group>
      )}

      <Form.Group className="mb-3 input input-md" controlId="password">
        <Form.Label>
          كلمة السر{" "}
          {addOrEdit === "add"
            ? ""
            : "(اتركه فارغ في حال لا تريد التعديل عليه)"}
        </Form.Label>
        <Form.Control
          autoComplete="new-password"
          type="password"
          {...register("password", {
            required: {
              value: addOrEdit === "add",
              message: "الرجاء إدخال الحقل",
            },
            minLength: {
              value: 6,
              message: "الحد الأدنى لحجم كلمة السر هو 6",
            },
          })}
        />

        {errors.password && (
          <Form.Text className="text-danger">
            {errors.password.message}
          </Form.Text>
        )}
      </Form.Group>

      <Form.Group className="mb-3 input input-md" controlId="roleId">
        <Form.Label>نوع المستخدم</Form.Label>
        <Form.Select
          {...register("roleId", {
            required: "الرجاء إدخال الحقل",
            onChange: () => setValue("permissionArray", []),
          })}
        >
          <option value="">الرجاء الاختيار</option>
          {RolesNoPeople.map((userRole) => (
            <option value={userRole.id} key={userRole.id}>
              {userRole.alias}
            </option>
          ))}
        </Form.Select>
        {errors.roleId && (
          <Form.Text className="text-danger">{errors.roleId.message}</Form.Text>
        )}
      </Form.Group>
      {/* eslint-disable-next-line eqeqeq */}
      {roleId == 1 && (
        <Form.Group className="mb-3 input input-md" controlId="permissionArray">
          <Form.Label>الصلاحيات</Form.Label>
          <Controller
            control={control}
            defaultValue=""
            name="permissionArray"
            rules={{
              required: {
                message: "الرجاء تعبئة الحقل",
                value: roleId === "1",
              },
            }}
            render={({ field: { onChange, name, ref /* value */ } }) => (
              <Select
                inputRef={ref}
                name={name}
                classNamePrefix="react-select"
                options={Permissions}
                value={permissionArrayValue}
                closeMenuOnSelect={false}
                isMulti
                getOptionLabel={(option) => option.alias}
                getOptionValue={(option) => option.id}
                onChange={(val) => {
                  onChange(val.map((item) => item.id));
                }}
              />
            )}
          />
          {errors.permissionArray && (
            <Form.Text className="text-danger">
              {errors.permissionArray.message}
            </Form.Text>
          )}
        </Form.Group>
      )}
      <Form.Group className="mb-3 input input-md" controlId="email">
        <Form.Label>البريد الالكتروني</Form.Label>
        <Form.Control
          autoComplete="new-password"
          type="email"
          {...register("email", {
            required: "الرجاء إدخال الحقل",
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: "الرجاء إدخال بريد إلكتروني صحيح",
            },
          })}
        />

        {errors.email && (
          <Form.Text className="text-danger">{errors.email.message}</Form.Text>
        )}
      </Form.Group>
      <Form.Group className="mb-3 input input-md" controlId="firstName">
        <Form.Label>الإسم الأول</Form.Label>
        <Form.Control
          autoComplete="new-password"
          type="firstName"
          {...register("firstName", {
            required: "الرجاء إدخال الحقل",
          })}
        />

        {errors.firstName && (
          <Form.Text className="text-danger">
            {errors.firstName.message}
          </Form.Text>
        )}
      </Form.Group>
      <Form.Group className="mb-3 input input-md" controlId="lastName">
        <Form.Label>الإسم الأخير</Form.Label>
        <Form.Control
          autoComplete="new-password"
          type="lastName"
          {...register("lastName", {
            required: "الرجاء إدخال الحقل",
          })}
        />

        {errors.lastName && (
          <Form.Text className="text-danger">
            {errors.lastName.message}
          </Form.Text>
        )}
      </Form.Group>
      <button
        type="submit"
        className="mb-3 btn btn--primary"
        style={{ width: "100%" }}
      >
        موافق
      </button>
    </form>
  );
}

AddEditEmployeeModal.defaultProps = {
  userData: {},
};

AddEditEmployeeModal.propTypes = {
  togglePrintDialog: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  userData: PropTypes.object,
  addOrEdit: PropTypes.string.isRequired,
};

export default AddEditEmployeeModal;
